document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".animate-in");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
});
